import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EVFormPageContent } from 'components/eventView/pages/EVFormPageContent';
import { motion } from 'framer-motion';
import { EEventForm } from 'graphql/fragment/__generated__/EEventForm';
import { AnimTap, EColors2, EFonts } from 'libs/styles/styling';
import { useContext, useEffect, useRef } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    title: string;
    form: EEventForm;
    onClose: () => void;

    className?: string;
}

export const EVFormPC = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const scrollContainerRef = useRef<HTMLDivElement>();
    const eventInfo = ctxEventView.eventData.eventInfo;

    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo(0, 0);
        }
    }, [scrollContainerRef.current, props.form]);

    if (!props.form) {
        return;
    }

    return (
        <S_EVDetailPagePC
            ref={scrollContainerRef}
            className={props.className}
            initial={{ x: '100%' }}
            animate={{ x: '0%' }}
            exit={{ x: '100%' }}
            transition={{ duration: 0.3, ease: 'easeIn' }}
            $background={eventInfo.headerImageUrl}
        >
            <S_TitleHeader>
                <S_Title>{props.title}</S_Title>
                <S_Close
                    {...AnimTap}
                    onClick={() => {
                        props.onClose();
                    }}
                >
                    <S_FontAwesomeIcon icon={['far', 'times']} />
                </S_Close>
            </S_TitleHeader>
            <S_EVFormPageContent form={props.form} />
        </S_EVDetailPagePC>
    );
};

const S_EVDetailPagePC = styled(motion.div)<{ $background: string }>`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    width: 530px;
    overflow-y: auto;
    overflow-x: hidden;
    background: #f6f9ff;
    box-shadow: -20px 9.002px 45.012px 0px rgba(0, 0, 0, 0.1);
    z-index: 300;
    cursor: auto;
`;

const S_Close = styled(motion.div)`
    position: absolute;
    right: 20px;
    top: 14px;
    width: 53px;
    height: 53px;
    border-radius: 50%;
    background-color: ${EColors2.DARK};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

const S_EVFormPageContent = styled(EVFormPageContent)`
    padding: 15px 10px 200px 10px;
`;

const S_FontAwesomeIcon = styled(FontAwesomeIcon)`
    color: white;
    font-size: 20px;
`;

const S_TitleHeader = styled.div`
    background: ${EColors2.GREY2};
    display: flex;
    background-size: cover;
    align-items: center;
    text-align: left;
    height: 80px;
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 100;
`;

const S_Title = styled.div`
    padding: 0px 0px 0px 35px;
    font-family: ${EFonts.Bold};
    font-size: 18px;
    line-height: 25px;
    line-height: normal;
    color: ${EColors2.DARK};
    width: 350px;
`;
